import type { User } from "@/types";

/**
 * Does this account have Opncue Plus right now?
 *
 * Mirrors `backend/api/src/modules/users/user-plan.ts`: Plus is a paid
 * `plan === "plus"` OR an unexpired `plusGrantUntil`. Reading `user.plan`
 * alone misses granted Plus — a referral reward — and would show a paying-in-
 * kind user a locked deck they are entitled to.
 *
 * Client-side, this decides only what is DRAWN. The server decides what is
 * sent, so a wrong answer here shows the wrong affordance and never grants
 * anything.
 */
export function isPlusUser(
  user: Pick<User, "plan" | "plusGrantUntil"> | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!user) return false;
  if (user.plan === "plus") return true;
  if (!user.plusGrantUntil) return false;
  const until = Date.parse(user.plusGrantUntil);
  return Number.isFinite(until) && until > now.getTime();
}
